const formatCurrency = (value, { locale = 'sv-SE', currency = 'SEK' } = {}) => {
  if (!value) {
    return ''
  }
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value)
}

export const Currency = ({ value }) => {
  return formatCurrency(value)
}
